<script setup lang="ts">
import { computed, ref } from 'vue'
import { useAuthStore } from '../stores/auth'

/**
 * Shown while the admin is logged in as a club member from the backend admin panel.
 * Admin-only, so the texts are Polish only.
 */
const authStore = useAuthStore()
const ending = ref(false)

const roleLabels: Record<string, string> = {
  OWNER: 'właściciel',
  SUPERVISOR: 'supervisor',
  COACH: 'trener',
  PLAYER: 'rodzic / zawodnik',
}

const info = computed(() => authStore.impersonation)
const who = computed(() => info.value?.name || info.value?.email || '')
const details = computed(() => {
  if (!info.value) return ''
  return [
    info.value.name ? info.value.email : null,
    roleLabels[info.value.role] ?? info.value.role,
    info.value.club_name,
  ]
    .filter(Boolean)
    .join(' · ')
})

const end = async () => {
  ending.value = true
  await authStore.logout()
  // The admin panel opened this window - close it; if the browser refuses, go to the login page
  window.close()
  setTimeout(() => window.location.replace('/login'), 300)
}
</script>

<template>
  <div
    v-if="authStore.isImpersonating && info"
    class="sticky top-0 z-[60] bg-amber-400 text-amber-950 text-sm"
    style="padding-top: var(--safe-area-top)"
  >
    <div class="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
      <div class="min-w-0">
        <span class="font-bold">🔑 Tryb admina:</span>
        jesteś zalogowany jako <span class="font-bold">{{ who }}</span>
        <span v-if="details" class="opacity-80"> ({{ details }})</span>
      </div>
      <button
        type="button"
        class="shrink-0 rounded-lg bg-amber-950 text-white px-3 py-1.5 font-semibold hover:bg-black disabled:opacity-60"
        :disabled="ending"
        @click="end"
      >
        {{ ending ? 'Kończę…' : 'Zakończ' }}
      </button>
    </div>
  </div>
</template>
